"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconInjuredFilled = function IconInjuredFilled(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.45 23L13.27 42H11C10.7348 42 10.4804 41.8946 10.2929 41.7071C10.1054 41.5196 10 41.2652 10 41V32C9.99573 29.7054 10.8681 27.4957 12.4387 25.8229C14.0094 24.15 16.1597 23.1402 18.45 23Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M34 41V42H30.73L29.37 37H30C31.0609 37 32.0783 37.4214 32.8284 38.1716C33.5786 38.9217 34 39.9391 34 41Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M40 32V41C40 41.2652 39.8946 41.5196 39.7071 41.7071C39.5196 41.8946 39.2652 42 39 42H37V41C37 39.1435 36.2625 37.363 34.9497 36.0503C33.637 34.7375 31.8565 34 30 34H28.55L25.55 23H31C32.1819 23 33.3522 23.2328 34.4441 23.6851C35.5361 24.1374 36.5282 24.8003 37.3639 25.636C38.1997 26.4718 38.8626 27.4639 39.3149 28.5558C39.7672 29.6478 40 30.8181 40 32Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M24.58 10.1L20 9.05999C20.6552 8.40221 21.4346 7.88133 22.293 7.52767C23.1514 7.17401 24.0716 6.99464 25 6.99999C26.125 6.99568 27.234 7.26691 28.23 7.78999L24.58 10.1Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.61 11.69L28.71 11L30.62 9.79001C31.0505 10.3657 31.3849 11.0073 31.61 11.69Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M31.94 14.84C31.7093 16.5962 30.8214 18.1996 29.4554 19.327C28.0893 20.4545 26.3466 21.0221 24.5786 20.9156C22.8106 20.809 21.1487 20.0362 19.9279 18.7529C18.7071 17.4696 18.0182 15.7712 18 14C17.9984 13.238 18.1235 12.481 18.37 11.76L31.94 14.84Z",
    fill: color
  }));
};

IconInjuredFilled.defaultProps = {
  color: 'black',
  size: 30
};
IconInjuredFilled.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconInjuredFilled;
exports.default = _default;